const ORCHESTRATOR_ID = "capital-one-prequalification-orchestrator";
const ALLOWED_ORIGIN = "https://digital-retail.autodriven.com";

/** Apply the vendor's sensor capability only to its known orchestrator frame. */
export function configureAutoDrivenFrame(frame: Pick<HTMLIFrameElement, "id" | "src" | "allow" | "title">): boolean {
    if (frame.id !== ORCHESTRATOR_ID) return false;
    try {
        if (new URL(frame.src).origin !== ALLOWED_ORIGIN) return false;
    } catch {
        return false;
    }
    const policies = (frame.allow || "").split(";").map(policy => policy.trim()).filter(Boolean);
    const retained = policies.filter(policy => !/^(accelerometer|gyroscope)(?:\s|$)/.test(policy));
    frame.allow = [...retained, `accelerometer ${ALLOWED_ORIGIN}`, `gyroscope ${ALLOWED_ORIGIN}`].join("; ");
    if (!frame.title) frame.title = "Capital One auto financing";
    return true;
}

/** The vendor appends directly to body; policy must precede document creation. */
export function prepareAutoDrivenInsertion(body: HTMLElement): () => void {
    const original = body.appendChild;
    const restore = () => {
        if (body.appendChild === append) body.appendChild = original;
    };
    function append<T extends Node>(this: HTMLElement, node: T): T {
        if (node instanceof HTMLIFrameElement && configureAutoDrivenFrame(node)) restore();
        return original.call(this, node) as T;
    }
    body.appendChild = append;
    return restore;
}
